module.exports = __webpack_public_path__ + "static/isr-803fa2bd37baa7f6e4b66698fb0cd579.png";